var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('contracts-table',{attrs:{"items":_vm.contracts,"loading":_vm.loading,"show-button":_vm.$can('manage', 'all'),"show-search":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }